Controller.$inject = [];

function Controller() {
}

export function HuiPopoverBody() {
    return {
        restrict: 'E',
        scope: {},
        transclude: true,
        controller: Controller,
        controllerAs: '$huiPopoverBodyCtrl',
        template: `
            <div class="hui-popover-body d-flex">
                <ng-transclude></ng-transclude>
            </div>
        `
    };
} 